import { render } from "./TrackingStatusesList.vue?vue&type=template&id=22fad994&ts=true"
import script from "./TrackingStatusesList.vue?vue&type=script&lang=ts"
export * from "./TrackingStatusesList.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/myparcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__